import Thematic from "@/inside/models/Text/Thematic";

/**
 * @property {Thematic[]} tree
 */
export default class ThematicTree {
    constructor(){
        this.tree = [];
    }
    /**
     * Returns a new `ThematicTree` instance hydrated with data from given `api_resource`
     * @param {Array} api_resource
     * @return {ThematicTree}
     */
    static fromAPI(api_resource){
        let out = new ThematicTree();
        Object.assign(out, {
            tree: api_resource.map((thematic_data) => {
                return Object.freeze(Thematic.fromAPI(thematic_data));
            })
        });
        return out
    }

    /**
    * Returns any `Thematic` instance corresponding to given `thematic_id` in thematics tree.
    * @param {string} thematic_id
    * @returns {Thematic|null}
    */
    findOne(thematic_id) {
        let out = null;
        let thematics = this.tree;
        for (let i = 0; i < thematics.length; i++) {
            if (thematics[i].id === thematic_id) {
                out = thematics[i];
                break;
            } else {
                out = thematics[i].findChild(thematic_id);

                if (out instanceof Thematic) {
                    break;
                }
            }
        }
        return out;
    }

}